export const COUPON_CODE_BADGE_BACKGROUND_URL = "portal/m/gifting-cart/savings-corner-badge.png";

export const TEXTS = {
    PLUS: "+",
    SAVE: "Save ₹{0}",
    SAVED: "₹{0} saved",
};
